import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../lib/api';
export function useGitHubRepos() {
    const [repos, setRepos] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const fetchRepos = useCallback(async (query) => {
        setIsLoading(true);
        setError(null);
        try {
            const params = query ? `?q=${encodeURIComponent(query)}` : '';
            const data = await apiFetch(`/api/github/repos${params}`);
            setRepos(data.repos || []);
        }
        catch (e) {
            setError(e instanceof Error ? e.message : 'Failed to load repos');
            setRepos([]);
        }
        finally {
            setIsLoading(false);
        }
    }, []);
    // Load on mount
    useEffect(() => {
        fetchRepos();
    }, [fetchRepos]);
    return { repos, isLoading, error, search: fetchRepos };
}
